import { createAction, props } from '@ngrx/store';
import { UnitGroups } from '../../../units/models/unit-groups';

export const getUnitGroupsSuccess = createAction(
  '[UnitGroups/API] Get Unit Groups Success',
  props<{unitGroups: UnitGroups[]}>()
);
export const getUnitGroupsFailure = createAction(
  '[UnitGroups/API] Get Unit Groups Failure',
  props<{error: any}>()
);

export type UnitGroupsApiActionsUnion = ReturnType<
  typeof getUnitGroupsSuccess |
  typeof getUnitGroupsFailure
>;
